import { render } from "./LibraryStudySpacesTile.vue?vue&type=template&id=4538fbde"
import script from "./LibraryStudySpacesTile.vue?vue&type=script&lang=js"
export * from "./LibraryStudySpacesTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__